import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step6({ data, onChange, onNext, onBack }) {

  const isValid =
  data.energia &&
    data.internet &&
    data.temaPrefeituraInvestir;
   

  return (
    <>
    <SectionCard
          title="Recursos básicos"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
        name="energia"
        title="Possui energia elétrica?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.energia}
        onSelect={(value) => onChange({ energia: value })}
      />
        <QuestionBlock
        name="internet"
        title="Há acesso regular à internet na sua residência?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.internet}
        onSelect={(value) => onChange({ internet: value })}
      />
      <QuestionBlock
        name="temaPrefeituraInvestir"
        title="Se pudesse escolher, qual seria o principal tema que a prefeitura precisa investir mais:"
        subtitle="(Resposta única)"
        options={[
          "Educação",
          "Saúde",
          "Segurança",
          "Saneamento básico" 
        ]}
        selected={data.temaPrefeituraInvestir}
        onSelect={(value) => onChange({ temaPrefeituraInvestir: value })}
      />
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
